import { docTypes } from '../../constants/documents.constants';

export const checkDocTypeHasSubtype = (docTypeId) => {
  return [
    docTypes.organizational,
    docTypes.meeting,
    docTypes.contract,
  ].includes(docTypeId);
};
